const baseRoute = '/coupon'

const makeCouponRoute = (suffix: string) => {
  return {
    url: `${baseRoute}/${suffix}`,
    suffixUrl: `/${suffix}`,
  }
}

export const CouponAreaRoutes = {
  route: baseRoute,
  Batches: makeCouponRoute('batches'),
  Create: makeCouponRoute('create'),
  CouponCode: makeCouponRoute('couponCode'),
}
